import { SaveButton } from "components/Buttons"
import Table from "components/Table"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Col, Input, Row } from "reactstrap"
import { getVisitorList } from "store/actions"
import visitorsListColumn from "./visitorsListColumns"
import Flatpickr from "react-flatpickr"

const VisitorListTab = ({ visitors, getVisitorList }) => {
  const [searchValue, setSearchValue] = useState("")
  const [dateValue, setDateValue] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "created_at",
    od: "desc",
  })

  const handlePageChange = page => {
    getVisitorList({
      ...defaultOrder,
      page: page,
      ...(searchValue.trim().length > 0 ? { search_term: searchValue } : {}),
      ...(dateValue ? { filter_date: dateValue } : {}),
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getVisitorList({
      o: sortField,
      od: sortOrder,
      page: 1,
      ...(searchValue.trim().length > 0 ? { search_term: searchValue } : {}),
      ...(dateValue ? { filter_date: dateValue } : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const handleSearch = () => {
    if (searchValue.trim().length > 0 || dateValue) {
      getVisitorList({
        ...defaultOrder,
        page: 1,
        ...(searchValue.trim().length > 0 ? { search_term: searchValue } : {}),
        ...(dateValue ? { filter_date: dateValue } : {}),
      })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    getVisitorList({
      ...defaultOrder,
      page: 1,
    })
    setSearchValue("")
    setDateValue(null)
    setShowResetButton(false)
  }

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-center">
        <Col xs="auto" className="my-1">
          <Input
            value={searchValue}
            onChange={event => {
              setSearchValue(event.target.value)
            }}
            placeholder="Search"
          />
        </Col>
        <Col xs="auto" className="my-1">
          <Flatpickr
            className="form-control bg-white"
            placeholder="Select Date"
            options={{
              altInput: true,
              altFormat: "Y-m-d",
              dateFormat: "Y-m-d",
            }}
            value={dateValue}
            onChange={(selectedDates, dateStr) => {
              setDateValue(dateStr)
            }}
          />
        </Col>
        <Col xs="auto" className="my-1">
          <SaveButton type="button" content="Search" onClick={handleSearch} />
        </Col>
        {showResetButton && (
          <Col xs="auto" className="my-1">
            <SaveButton
              type="button"
              content="Reset"
              color="light"
              onClick={handleResetSearch}
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col>
          <Table
            data={visitors?.data}
            columns={visitorsListColumn()}
            paginationData={{
              current_page: visitors?.current_page,
              last_page: visitors?.last_page,
              total_items: visitors?.total,
              items_per_page: visitors?.per_page,
              from: visitors?.from,
              to: visitors?.to,
              first_page: 1,
            }}
            onPageChange={handlePageChange}
            onTableSort={handleSort}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  visitors: state.Visitors.visitors,
})

const mapDispatchToProps = dispatch => ({
  getVisitorList: values => dispatch(getVisitorList(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(VisitorListTab)
